export const VALUES = {
  MENU: {
    DRAWER_WIDTH: '20%'
  }
}

export const typeContract = [

  {key: 'CONTRATO_POR_OBRA_LABOR', value: "Contrato por obra labor" },
  {key: 'CONTRATO_TERMINO_INDEFINIDO', value: "Contrato término Indefinido"},
  {key: 'CONTRATO_PRESTACION_DE_SERVICIO', value: "Contrato Prestación de servicio "},
  {key: 'CONTRATO_TERMINO_FIJO', value: "Contrato término fijo"},
  //{key: 'CONTRATO_DE_APRENDIZAJE', value: "Contrato de aprendizaje"}
]

 export const Logo = {
  logo:"http://cuidadoseguro.com.co/principal/wp-content/uploads/2020/07/LOGO_CSC_HORINZONTAL.png"
 
}

const TRANSLATE = {
  LABELS: {
    ASSIGNED_ROLES: 'Roles Asignados'
  },
  BUTTONS: {
    ROLES: 'Roles',
    APPLY: 'APLICAR',
    CANCEL: 'CANCELAR'
  },
  API_MESSAGES: {
    ROLES: {
      GET_ERROR: 'Ocurrió un error procesando la solicitud, inténtelo nuevamente',
      POST_SUCCESS: 'Se guardaron los roles exitosamente',
      POST_ERROR: 'Ocurrió un error procesando la solicitud, inténtelo nuevamente'
    }
  },
  FORM: {
    NO_MORE_THAN_N_CHARACTERS: 'No se permite más de %n% caracteres',
    ENTER_VALID_NAME_MESSAGE: 'Ingrese un nombre válido',
    MANDATORY_SUBDOMAIN_MESSAGE: 'Este campo es obligatorio',
    VALID_DESCRIPTION_MESSAGE: 'Ingrese una descripción válida',
    SUBDOMAIN_SUCCESSFULLY_SAVED: 'Se guardó el subdominio exitosamente'
  },
  FOOTER: {
    COPY_RIGHT_MSG: `© Copyright ${ new Date().getFullYear()} Todos los derechos reservados CUIDADO SEGURO EN CASA SA`,
    DATA_PROTECTION_POLICY_MSG: 'Política de protección de datos personales - Conozca nuestra política para garantizar la seguridad de sus datos personales.'
  }
};

export default TRANSLATE;
